import {useState} from 'react'
import {Building2, LockKeyhole, ShieldCheck, UserRound, X} from 'lucide-react'

import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {getUserData} from '../auth'
import {isAdmin, isSuperAdmin} from '../auth/core/Auth'
import ProfileChangePasswordPage from './ProfileChangePasswordPage'
import ProfileDataPage from './ProfileDataPage'
import '../../pages/users/users-admin.css'
import '../../pages/users/users-admin-extra.css'
import './profile-modal.css'

type Props = {
  onClose: () => void
  onProfileUpdated?: () => void
}

type TabId = 'profile' | 'password'

const ProfileHeader = ({onClose, onProfileUpdated}: Props) => {
  const [activeTab, setActiveTab] = useState<TabId>('profile')
  const [profile, setProfile] = useState<any>(() => getUserData())

  function changeTab(tab: TabId) {
    setActiveTab(tab)
    const gtag = (window as any).gtag
    gtag?.('event', 'click', {
      event_category: 'Perfil do Usuário',
      event_label: tab === 'profile' ? 'Dados Pessoais' : 'Alterar Senha',
    })
  }

  const role = isSuperAdmin() ? 'Super administrador' : isAdmin() ? 'Administrador' : 'Membro'
  const avatar = profile?.src || toAbsoluteUrl('/media/icons/duotune/general/gen049.svg')

  return (
    <div className='profile-modal'>
      <header className='profile-modal__header'>
        <span className='profile-modal__header-icon' aria-hidden='true'>
          <UserRound size={22} />
        </span>
        <div>
          <small>Conta e segurança</small>
          <h2 id='profile-modal-title'>Perfil do usuário</h2>
          <p>Atualize suas informações pessoais e proteja o acesso à sua conta.</p>
        </div>
        <button
          type='button'
          className='profile-modal__close'
          aria-label='Fechar perfil'
          onClick={onClose}
        >
          <X size={18} />
        </button>
      </header>

      <section className='profile-modal__identity' aria-label='Resumo da conta'>
        <span className='profile-modal__avatar'>
          <img src={avatar} alt='' />
        </span>
        <span className='profile-modal__identity-copy'>
          <strong>{profile?.name}</strong>
          <small>{profile?.email}</small>
        </span>
        <span className='profile-modal__identity-tags'>
          <span>
            <Building2 size={12} /> {profile?.company_name || 'Empresa não informada'}
          </span>
          <span>
            <ShieldCheck size={12} /> {role}
          </span>
        </span>
      </section>

      <nav className='profile-modal__tabs' role='tablist' aria-label='Configurações do perfil'>
        <button
          type='button'
          role='tab'
          aria-selected={activeTab === 'profile'}
          aria-controls='profile-personal-panel'
          className={activeTab === 'profile' ? 'is-active' : ''}
          onClick={() => changeTab('profile')}
        >
          <span>
            <UserRound size={17} />
          </span>
          <span>
            <strong>Dados pessoais</strong>
            <small>Nome, e-mail e foto</small>
          </span>
        </button>
        <button
          type='button'
          role='tab'
          aria-selected={activeTab === 'password'}
          aria-controls='profile-password-panel'
          className={activeTab === 'password' ? 'is-active' : ''}
          onClick={() => changeTab('password')}
        >
          <span>
            <LockKeyhole size={17} />
          </span>
          <span>
            <strong>Alterar senha</strong>
            <small>Segurança da conta</small>
          </span>
        </button>
      </nav>

      <div className='profile-modal__content'>
        <div
          id='profile-personal-panel'
          role='tabpanel'
          hidden={activeTab !== 'profile'}
          aria-label='Dados pessoais'
        >
          <ProfileDataPage
            onUpdated={(updatedProfile) => {
              setProfile((current: any) => ({...current, ...updatedProfile}))
              onProfileUpdated?.()
            }}
          />
        </div>
        <div
          id='profile-password-panel'
          role='tabpanel'
          hidden={activeTab !== 'password'}
          aria-label='Alterar senha'
        >
          <ProfileChangePasswordPage />
        </div>
      </div>
    </div>
  )
}

export {ProfileHeader}
